// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// npm-packaged components — registered here by hand; re-add if a
// `stimulus:manifest:update` regeneration ever drops this block.
import AutoSubmit from "@stimulus-components/auto-submit"
application.register("auto-submit", AutoSubmit)

import BankAppRedirectController from "./bank_app_redirect_controller"
application.register("bank-app-redirect", BankAppRedirectController)

import BankLinkFieldsController from "./bank_link_fields_controller"
application.register("bank-link-fields", BankLinkFieldsController)

import BannerSlotController from "./banner_slot_controller"
application.register("banner-slot", BannerSlotController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ComboComponentsController from "./combo_components_controller"
application.register("combo-components", ComboComponentsController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import DiscountKindController from "./discount_kind_controller"
application.register("discount-kind", DiscountKindController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import FormRefreshController from "./form_refresh_controller"
application.register("form-refresh", FormRefreshController)

import CelebrationController from "./celebration_controller"
application.register("celebration", CelebrationController)

import CelebrationPreviewController from "./celebration_preview_controller"
application.register("celebration-preview", CelebrationPreviewController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import MoneyInputController from "./money_input_controller"
application.register("money-input", MoneyInputController)

import OnboardingRowsController from "./onboarding_rows_controller"
application.register("onboarding-rows", OnboardingRowsController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import RetentionPopupController from "./retention_popup_controller"
application.register("retention-popup", RetentionPopupController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import ScrollHintController from "./scroll_hint_controller"
application.register("scroll-hint", ScrollHintController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TierThresholdController from "./tier_threshold_controller"
application.register("tier-threshold", TierThresholdController)

import TwoFactorController from "./two_factor_controller"
application.register("two-factor", TwoFactorController)

import ZnsPreviewController from "./zns_preview_controller"
application.register("zns-preview", ZnsPreviewController)

import Ui__SearchableSelectController from "./ui/searchable_select_controller"
application.register("ui--searchable-select", Ui__SearchableSelectController)

import Ui__TransitionController from "./ui/transition_controller"
application.register("ui--transition", Ui__TransitionController)
